const selectPublic = (state) => state.public;
const selectCompare = (state) => selectPublic(state).compare;
const selectDiscount = (state) => selectPublic(state).discount;
const selectBlogState = (state) => selectPublic(state).blogs;
const selectArticleState = (state) => selectPublic(state).articles;

export const selectCompareData = (type) => (state) => {
  const compare = selectCompare(state);
  const data = compare[type];
  return {
    loading: compare.loading,
    data,
  };
};

export const selectDiscountData = (type) => (state) => {
  const discount = selectDiscount(state);
  const data = discount[type];
  return {
    loading: discount.loading,
    data,
  };
};

export const getBlogs = (state) => {
  const { postIds, entities } = selectBlogState(state);
  return postIds.map((id) => entities[id]);
};

export const loadingBlogs = (state) => {
  const { loading } = selectBlogState(state);
  return loading;
};

export const selectBlog = (slug) => (state) => {
  const { entities } = selectBlogState(state);
  return entities[slug];
};

export const selectArticle = (type) => (state) => {
  const articles = selectArticleState(state);
  return {
    article: articles[type],
    loading: articles.loading,
  };
};
